import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PropertyInsurance as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import CircleWithCount from 'Icons/CircleWithCount';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import CurrencyInput from '../Fields/CurrencyInput';
import FieldList from '../Fields/FieldList';
import TextInput from '../Fields/TextInput';
import SelectInput from '../Fields/SelectInput';
import Section from '../Section';

const policyTypes = [
  {
    id: '',
    value: '- Please Select -',
  },
  {
    id: 'auto',
    value: 'Auto',
  },
  {
    id: 'homeowners',
    value: 'Homeowners',
  },
  {
    id: 'renters',
    value: 'Renters',
  },
  {
    id: 'umbrella',
    value: 'Umbrella',
  },
  {
    id: 'other',
    value: 'Other',
  },
];

class PropertyInsuranceList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      propertyInsuranceCompany: '',
      propertyInsuranceType: '',
    };

    this.onChange = this.onChange.bind(this);
    this.getPolicyName = this.getPolicyName.bind(this);
    this.hasOtherType = this.hasOtherType.bind(this);
    this.hasPropertyLimit = this.hasPropertyLimit.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  getPolicyName() {
    const { propertyInsuranceCompany, propertyInsuranceType } = this.state;
    const nameList = [];
    if (propertyInsuranceType) {
      const typeName = policyTypes.filter(
        type => type.id === propertyInsuranceType,
      )[0].value;
      nameList.push(typeName);
    }
    if (propertyInsuranceCompany) nameList.push(propertyInsuranceCompany);
    return nameList.join(' - ') || 'New policy';
  }

  hasOtherType() {
    const { propertyInsuranceType } = this.state;
    return propertyInsuranceType === 'other';
  }

  hasPropertyLimit() {
    const { propertyInsuranceType } = this.state;
    return (
      ['auto', 'homeowners', 'renters', 'other'].indexOf(
        propertyInsuranceType,
      ) > -1
    );
  }

  render() {
    const {
      getPolicyName,
      hasOtherType,
      hasPropertyLimit,
      onChange,
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={getPolicyName()}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <SelectInput
          label="Policy Type"
          placeholder="Policy type"
          name={`propertyInsuranceType.${id}`}
          answerKey="propertyInsuranceType"
          options={policyTypes}
          onChange={(name, value) => onChange('propertyInsuranceType', value)}
        />
        {hasOtherType() && (
          <TextInput
            placeholder="Other policy type"
            name={`propertyInsuranceOtherType.${id}`}
            answerKey="propertyInsuranceOtherType"
          />
        )}
        <TextInput
          placeholder="Insurance company"
          name={`propertyInsuranceCompany.${id}`}
          answerKey="propertyInsuranceCompany"
          onChange={(name, value) => onChange('propertyInsuranceCompany', value)
          }
        />
        {hasPropertyLimit() && (
          <CurrencyInput
            placeholder="Property limit"
            name={`propertyInsurancePropertyLimit.${id}`}
            answerKey="propertyInsurancePropertyLimit"
          />
        )}
        <CurrencyInput
          placeholder="Liability limit"
          name={`propertyInsuranceLiabilityLimit.${id}`}
          answerKey="propertyInsuranceLiabilityLimit"
        />
        <CurrencyInput
          placeholder="Deductibles"
          name={`propertyInsuranceDeductible.${id}`}
          answerKey="propertyInsuranceDeductible"
        />
        <TextInput
          placeholder="Description"
          name={`propertyInsuranceDescription.${id}`}
          answerKey="propertyInsuranceDescription"
        />
      </LabeledVerticalExpander>
    );
  }
}

PropertyInsuranceList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

PropertyInsuranceList.defaultProps = {
  expanded: false,
};

const PropertyInsurance = () => {
  const [count, setCount] = React.useState(0);

  return (
    <Section
      CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}
      transitionSpeed={0.25}
      height={400}
      title="Property & Casualty Insurance"
      sectionKey={SectionKey}
      expanded={QueryVal(section) === SectionKey}
    >
      <FieldList
        onCountUpdate={setCount}
        label="Policy - Property & Casualty"
        addLabel="Add a policy"
        keyPrefix="propertyInsurances"
        Of={PropertyInsuranceList}
      />
    </Section>
  );
};

export default PropertyInsurance;
